import SuccessModal from '@/Modals/SuccessModal';
import React, { createContext, useContext, useRef } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const modalRef = useRef();

    const openModalInfo = (message) => {
        if (modalRef.current) {
            modalRef.current.open(message);
        }
    };

    return (
        <ModalContext.Provider value={{ openModalInfo }}>
            {children}
            <SuccessModal ref={modalRef} />
        </ModalContext.Provider>
    );
};

export const useModalInfo = () => {
    return useContext(ModalContext);
};